import React, { useState } from "react";
import ReactEcharts from "echarts-for-react";

const BarChart = (props) => {


  const symbol = props.symbol || '';

  const getOptions = () => ({
    title: {
      text: props.title,
      subtext: props.subTitle,
      left: 'center'
    },
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      orient: 'horizontal',
      left: 'center',
      top: 'bottom'
    },

    grid: {
      top: '15%', // Espacio superior
      left: '10%', // Espacio izquierdo
      right: '10%', // Espacio derecho
      bottom: '30%', // Aumenta este valor para dar más espacio en la parte inferior
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: props.categories,
      axisLabel: {
        rotate: 30,
        interval: 0,
        textStyle: {
          fontSize: 12,
          color: '#333',
        }
      }
    },
    yAxis: [
      {
        type: 'value',
        name: props.nameBar,
        position: 'left'
      },
      {
        type: 'value',
        name: props.nameLine,
        position: 'right'
      }
    ],
    series: [
      {
        name: props.nameBar,
        type: 'bar',
        data: props.applications, // Datos para las barras (ej. total de frutos)
        itemStyle: {
          color: props.barColor ? props.barColor : '#5470C6'
        },
        label: {
          show: true,
          position: 'insideBottom',
          formatter: (params) => {
            const value = Number(params.value);

            if (!isNaN(value)) {
              return new Intl.NumberFormat('es-CO', {
                minimumFractionDigits: props.decimals ?? 0,
                maximumFractionDigits: props.decimals ?? 0,
              }).format(value) + symbol;
            }

            return '0' + symbol;
          }
        }
      }   

    ]
  });

  return (
    <div className="">
      <ReactEcharts
        ref={props.chartRef}
        option={getOptions()}
        style={{ height: 300 }}
      />
    </div>
  );
};

export default BarChart;
